













import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class FlashError extends Vue {
  @Prop() id!: string;
  @Prop() message!: string;

  // noinspection JSUnusedGlobalSymbols
  get show(): boolean {
    return !!(this.message && this.message !== '');
  }
}
